module.exports = __webpack_public_path__ + "static/img/bottomImg.bb540c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/statistics-charts/insurance-statistics/images/bottomImg.png
// module id = Gvby
// module chunks = 183